export default "__VITE_ASSET__566d2dd9__"